import { WorkflowName } from './enums/WorkflowName'
import WorkflowItemJson from './interfaces/WorkflowItemJson'
import WorkflowActivationPeriods from './WorkflowActivationPeriods'

export default class WorkflowItem {
  name: WorkflowName
  activationPeriods: WorkflowActivationPeriods

  constructor(
    name: WorkflowName,
    activationPeriods: WorkflowActivationPeriods,
  ) {
    this.name = name
    this.activationPeriods = activationPeriods
  }

  static fromJson(data: WorkflowItemJson) {
    return new this(
      data.name,
      WorkflowActivationPeriods.fromJson(data.activationPeriods),
    )
  }
}
